import { RESEND_EMAIL_VERIFICATION_DELAY, LOCAL_STORAGE_TIMER_KEY } from 'constants/index';

export const startEmailTimer = () => {
  const resendEmailData = { endTime: Date.now() + RESEND_EMAIL_VERIFICATION_DELAY };
  localStorage.setItem(LOCAL_STORAGE_TIMER_KEY, JSON.stringify(resendEmailData));
};
